// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import lprobEntity from './entities/lprob.json';
import lprobMenu from '../pages/lprob/menu.json';
import lprobFullForm from '../pages/lprob/forms/full.json';
import lprobContextForm from '../pages/lprob/forms/context.json';
import lprobMiniForm from '../pages/lprob/forms/mini.json';
import lprobLookupForm from '../pages/lprob/forms/lookup.json';
import lprobTableView from '../pages/lprob/views/table.json';
import lprobStagesView from '../pages/lprob/views/stages.json';
import lprobCardsView from '../pages/lprob/views/cards.json';
import lprobInlineView from '../pages/lprob/views/inline.json';
import lprobBacklogView from '../pages/lprob/views/backlog.json';
import lprobSplitView from '../pages/lprob/views/split.json';
import lprobCalendarView from '../pages/lprob/views/calendar.json';
import lprobDashboardView from '../pages/lprob/views/dashboard.json';

/** Тип запису «Правова проблема» зі сторінками пакета: меню, форми та подання з pages/lprob/. */
export const lprobDefinition: IRecordTypeDefinition = {
  ...lprobEntity,
  views: assembleViewSet({
      table: lprobTableView,
      stages: lprobStagesView,
      cards: lprobCardsView,
      inline: lprobInlineView,
      backlog: lprobBacklogView,
      split: lprobSplitView,
      calendar: lprobCalendarView,
      dashboard: lprobDashboardView,
  }),
  form: lprobFullForm,
  forms: { full: lprobFullForm, context: lprobContextForm, mini: lprobMiniForm, lookup: lprobLookupForm },
  menu: lprobMenu,
} as IRecordTypeDefinition;
